import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { ValidationProvider } from 'vee-validate'
import Buefy from 'buefy'
import { i18n } from '@/plugins/i18n'
import './vee-validate'
import '@mdi/font/css/materialdesignicons.css'
import Vue2Editor from 'vue2-editor'
import 'animate.css'

Vue.config.productionTip = false
Vue.component('ValidationProvider', ValidationProvider)
Vue.use(Buefy)
Vue.component('Vue2Editor', Vue2Editor)
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
